"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const simpleId_1 = require("../../../utilites/simpleId");
var videoOutputType;
(function (videoOutputType) {
    videoOutputType["Any"] = "any";
    videoOutputType["Monitor"] = "monitor";
    videoOutputType["Projection"] = "projection";
    videoOutputType["Handheld"] = "handheld";
    videoOutputType["Headset"] = "headset";
})(videoOutputType = exports.videoOutputType || (exports.videoOutputType = {}));
var videoOutputOrientation;
(function (videoOutputOrientation) {
    videoOutputOrientation["Portrait"] = "portrait";
    videoOutputOrientation["Landscape"] = "landscape";
})(videoOutputOrientation = exports.videoOutputOrientation || (exports.videoOutputOrientation = {}));
class AWOutputVideo {
    constructor(id) {
        this.id = '';
        this.type = videoOutputType.Any;
        this.resolution = null;
        this.orientation = videoOutputOrientation.Landscape;
        this.order = 0;
        if (id) {
            this.id = id;
        }
    }
    static preset() {
        return new AWOutputVideo(simpleId_1.simpleId());
    }
}
exports.AWOutputVideo = AWOutputVideo;
